import { SESSION_STATUS_LABELS, type SessionStatus } from '@diana/contracts';
import './ShootProgress.css';
const stages = ['NewRequest', 'InDiscussion', 'Scheduled', 'Editing', 'Delivered'] as const;
/** Desktop shows the full sequence; mobile emphasizes only the current stage. */
export function ShootProgress({ status }: { status: SessionStatus }) {
  const active = stages.findIndex((stage) => stage === status);
  return (
    <nav className="shoot-progress" aria-label="Shoot progress" data-status={status}>
      {status === 'Canceled' ? (
        <span className="shoot-progress__canceled" aria-current="step">
          {SESSION_STATUS_LABELS.Canceled}
        </span>
      ) : (
        stages.map((stage, index) => (
          <span
            key={stage}
            className={`shoot-progress__step${index <= active ? ' is-complete' : ''}`}
            aria-current={index === active ? 'step' : undefined}
            title={SESSION_STATUS_LABELS[stage]}
          >
            <i aria-hidden="true" />
            <span
              className={
                index === active
                  ? 'shoot-progress__label'
                  : 'shoot-progress__label shoot-progress__label--other'
              }
            >
              {SESSION_STATUS_LABELS[stage]}
            </span>
          </span>
        ))
      )}
    </nav>
  );
}
